
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tooling/page/[page]",
      function () {
        return require("private-next-pages/tooling/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tooling/page/[page]"])
      });
    }
  